import ResultTable from "../../Table/ResultTable";
import {MessageCodes} from "../MessageCodes";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ComparisonCSName from "../../ComparisonCSName";

const renderSections = (row) => {
    const components = []
    row.data.forEach((x, idx) => {
        x.data.forEach((r, idy) => {
            components.push(
                <>
                    <ResultRow>
                        {
                            idy === 0 && (
                                <ResultBodyCell rowSpan={x.data.length} style={{textAlign: 'left', verticalAlign: 'bottom', width: 100}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                            )
                        }
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{HecRasHelper.isUndefined(r.base_start_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{HecRasHelper.isUndefined(r.base_end_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{HecRasHelper.isUndefined(r.base_elev)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_start_sta), HecRasHelper.isUndefined(r.cmp_start_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_end_sta), HecRasHelper.isUndefined(r.cmp_end_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right', width: 100}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_elev), HecRasHelper.isUndefined(r.cmp_elev))}</ResultBodyCell>
                    </ResultRow>
                </>
            )
        })
    })
    return components
}

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TOBST001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the obstructed areas between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plans at the following {row.data.length} cross-sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={6}>Obstructed Areas</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Start Sta</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>End Sta</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Elev</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Start Sta</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>End Sta</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Elev</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                renderSections(row)
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const C21 = {
    RenderDescription,
}